import { createContext } from "react";

const Data = createContext({});
const Filters = createContext({});


export { Data, Filters };
